import { getRoutesForPath } from "./getRoutesForPath";
import { Route } from "./routes";

/**
 * Gets the associated route object for the given pathname.
 * @param pathname
 * @returns `null` if the `pathname`:
 *
 * - cannot be found inside `routes`
 * - is an array
 * - is `undefined`
 */
export const getRoute = (
	pathname?: string | readonly string[],
): Route | null => {
	if (pathname === undefined || Array.isArray(pathname)) {
		return null;
	}

	// Cast is neccessary here due to TypeScript bug - see
	// https://github.com/microsoft/TypeScript/issues/17002
	const items = getRoutesForPath((pathname as string).split("/"));
	return items.length > 0 ? items[items.length - 1]! : null;
};
